module.exports = __webpack_public_path__ + "img/navigation_browser_2.bba7be63.png";